import React from 'react'
import { getFullName } from './../../formatters'
import { getDefaultBio } from './../../content'

import './MeetAgent.component.scss'

const MeetAgent = ({ subsiteData }) => {
  const fullName = getFullName(subsiteData)
  const bio = (subsiteData?.s_about || getDefaultBio(subsiteData)).trim().replace(/'/g, "'")

  return (
    <section id='MeetAgent' className='subsite-section is-soft'>
      <div className='subsite-shell'>
        <h2 className='meet-agent-title'>{fullName ? `Meet ${fullName}` : 'Meet Your Agent'}</h2>
        <div className='meet-agent-bio' dangerouslySetInnerHTML={{ __html: bio }}></div>
      </div>
    </section>
  )
}

export default MeetAgent
